import React from 'react';

import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';
import { useExperienceEntityVenues } from 'modules/experience-core';

import Nps from '../Nps';
import useIsNpsFlagEnabled from '../useIsNpsFlagEnabled';

type ExperienceNpsProps = {
  manual?: boolean;
  onClose?: () => void;
};

export const ExperienceNps = ({ manual = false, onClose }: ExperienceNpsProps) => {
  const venueExperienceEntities = useExperienceEntityVenues();
  const venue = venueExperienceEntities[0].experienceEntityObject as Venue;
  const isNpsFlagEnabled = useIsNpsFlagEnabled();
  return isNpsFlagEnabled && venue ? <Nps venue={venue} manual={manual} onClose={onClose} /> : null;
};
